module.exports = __webpack_public_path__ + "img/301.a1ed8b4b.png";